<template>
    <tabs :options="{ useUrlFragment: false }">
        <tab name="Long Banners">
            <div class="containter eventhall_flags">
        <div class="form-group row">
            <div class="col-lg-12">

                <div id ="multiple_images">
                    <input
                        placeholder="Upload Multiple Long Banners"
                        type="file"
                        class="form-control"
                        @change="updateBannerLong"
                        multiple="multiple"
                        accept="image/jpeg"
                        
                      >
                      <p> (Should be in image format-Max Limit 12 and JPEG only)</p>
                </div>
       
            </div>
            <div class="image-list">
                        <div class="image-item" v-for="file in item.banner_long" v-bind:key="file">
                        <img :src="IMAGE_URL + file.key" alt="Image 1" >
                        <div class="image-details">
                            <span class="image-name">{{getFileName(file.key)}}</span>
                            <button type="button" class="remove-btn" @click="removeBannerLongAsset($event, file.key)">Remove</button>
                        </div>
                        </div>
                </div>
        </div>


            </div>
        </tab>
        <tab name="Medium Banners">
            <div class="containter eventhall_flags">

                <div class="form-group row">
                <div class="col-lg-12">

                    <div id ="multiple_images">
                        <input
                            placeholder="Upload Multiple Medium Banners"
                            type="file"
                            class="form-control"
                            @change="updateBannerMedium"
                            multiple="multiple"
                            accept="image/jpeg"
                            
                        >
                        <p> (Should be in image format-Max Limit 8 and JPEG only)</p>
                    </div>
        
                </div>
                <div class="image-list">
                    <div class="image-item" v-for="file in item.banner_medium" v-bind:key="file">
                    <img :src="IMAGE_URL + file.key" alt="Image 1" >
                    <div class="image-details">
                        <span class="image-name">{{getFileName(file.key)}}</span>
                        <button type="button" class="remove-btn" @click="removeBannerMediumAsset($event, file.key)">Remove</button>
                    </div>
                    </div>
                </div>
        </div>


            </div>
        </tab>
        <tab name="Small Banners">
            <div class="containter eventhall_flags">

                <div class="form-group row">
                <div class="col-lg-12">

                    <div id ="multiple_images">
                        <input
                            placeholder="Upload Multiple Small Banners"
                            type="file"
                            class="form-control"
                            @change="updateBannerSmall"
                            multiple="multiple"
                            accept="image/jpeg"
                            
                        >
                        <p> (Should be in image format-Max Limit 9 and JPEG only)</p>
                    </div>
        
                </div>
                <div class="image-list">
                    <div class="image-item" v-for="file in item.banner_small" v-bind:key="file">
                    <img :src="IMAGE_URL + file.key" alt="Image 1" >
                    <div class="image-details">
                        <span class="image-name">{{getFileName(file.key)}}</span>
                        <button type="button" class="remove-btn" @click="removeBannerSmallAsset($event, file.key)">Remove</button>
                    </div>
                    </div>
                </div>
        </div>


            </div>
        </tab>

        
    </tabs>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import _ from 'lodash';
import constants from "@/config/constants";
   
import { upload, remove } from "@/services/FileUploader";
import ObjectID from 'bson-objectid';
export default{
    name: "BannersTab",
    data() {
        return {
            IMAGE_URL:constants.IMAGE_URL
        }
    },
    computed: {
        ...mapGetters("EventHallsSingle", [
            "item",
        ])
    },
    methods: {
        ...mapActions("EventHallsSingle", [
            'setBannerLong',
            'removeBannerLong',
            "setBannerSmall",
            "setBannerMedium",
            "removeBannerSmall",
            "removeBannerMedium"
        ]),
        getFileName(str){
                let stringNew =  str.split("/").pop();
                return stringNew.slice(-25);
        },
        validate_file(fileInfo) {
            if (_.has(fileInfo, 'key'))
                return fileInfo;
        return null;
        },
       
        async updateBannerLong(e){
                try {
                    
                    let image_qty = 12;
                    let totalDocs = this.item.banner_long.length + e.target.files.length;
                    if (totalDocs > image_qty) {
                        alert(`You can not upload more than ${image_qty} Banner Long in the Event Hall`);
                        return;
                    }
                    const files = e.target.files;
                    for(let file of files){
                        let file_size = file.size;
                           let img_ext = file.name.split('.').pop().toLowerCase();
                            if(['jpg','jpeg'].includes(img_ext) ==false){
                                this.errCb();
                                return;
                                
                            }
                        
                    }
                    const user = JSON.parse(localStorage.getItem('user'));
                    for(let file of files){
                        let file_size = file.size;
                        let id = ObjectID();
                        let resp = await upload(file, id, "event-hall", '720X1800', 'flags');
                        let fileKey = resp.data.data.key?resp.data.data.key:resp.data.data.Key; 
                        let extension = fileKey.split('.').pop();

                        this.setBannerLong({
                            key: fileKey,
                            old_key: fileKey,
                            temp_key: id,
                            size: file_size.toString(),
                            extension: extension,
                            uploadedBy: user.first_name + ' ' + user.last_name,
                            uploadedAt: '2023.01.01',
                        });
                    }
                    
                } catch (e) {
                    console.log("Error in set",e);
                    this.$flashMessage.show({
                    group: 'event_hall_index',
                    type: 'error',
                    title: 'Error',
                    html  : "<ul><li>Invalid File/Doc format.Please use described valid format</li></ul>"
                    });
                }
        },
        removeBannerLongAsset(e, id) {
            console.log("removeid",id);
            this.$swal({
                title: "Are you sure ? ",
                text: "To fully delete the file submit the form.",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "Delete",
                confirmButtonColor: "#dd4b39",
                focusCancel: true,
                reverseButtons: true
            }).then(result => {
                if (typeof result.dismiss === "undefined") {
                    remove(id).then(() => {
                    this.removeBannerLong(id);
                    })
                }
            });
        },
        async updateBannerSmall(e){
                try {
                    
                    let image_qty = 9;
                    let totalDocs = this.item.banner_small.length + e.target.files.length;
                    if (totalDocs > image_qty) {
                        alert(`You can not upload more than ${image_qty} Banner Small in the Event Hall`);
                        return;
                    }
                    const files = e.target.files;
                    for(let file of files){
                        let file_size = file.size;
                           let img_ext = file.name.split('.').pop().toLowerCase();
                            if(['jpg','jpeg'].includes(img_ext) ==false){
                                this.errCb();
                                return;
                                
                            }
                    }
                    const user = JSON.parse(localStorage.getItem('user'));
                    for(let file of files){
                        let file_size = file.size;
                        let id = ObjectID();
                        let resp = await upload(file, id, "event-hall", '1800X600', 'flags');
                        let fileKey = resp.data.data.key?resp.data.data.key:resp.data.data.Key; 
                        let extension = fileKey.split('.').pop();

                        this.setBannerSmall({
                            key: fileKey,
                            old_key: fileKey,
                            temp_key: id,
                            size: file_size.toString(),
                            extension: extension,
                            uploadedBy: user.first_name + ' ' + user.last_name,
                            uploadedAt: '2023.01.01',
                        });
                    }
                    
                } catch (e) {
                    console.log("Error in set",e);
                    this.$flashMessage.show({
                    group: 'event_hall_index',
                    type: 'error',
                    title: 'Error',
                    html  : "<ul><li>Invalid File/Doc format.Please use described valid format</li></ul>"
                    });
                }
        },
        removeBannerSmallAsset(e, id) {
            this.$swal({
                title: "Are you sure ? ",
                text: "To fully delete the file submit the form.",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "Delete",
                confirmButtonColor: "#dd4b39",
                focusCancel: true,
                reverseButtons: true
            }).then(result => {
                if (typeof result.dismiss === "undefined") {
                    remove(id).then(() => {
                    this.removeBannerSmall(id);
                    })
                }
            });
        },
        async updateBannerMedium(e){
                try {
                    let image_qty = 8;
                    let totalDocs = this.item.banner_medium.length + e.target.files.length;
                    if (totalDocs > image_qty) {
                        alert(`You can not upload more than ${image_qty} Banner Medium in the Event Hall`);
                        return;
                    }
                    const files = e.target.files;
                    for(let file of files){
                        let file_size = file.size;
                           let img_ext = file.name.split('.').pop().toLowerCase();
                            if(['jpg','jpeg'].includes(img_ext) ==false){
                                this.errCb();
                                return;
                                
                            }
                    }
                    const user = JSON.parse(localStorage.getItem('user'));
                    for(let file of files){
                        let file_size = file.size;
                        let id = ObjectID();
                        let resp = await upload(file, id, "event-hall", '1800X600', 'flags');
                        let fileKey = resp.data.data.key?resp.data.data.key:resp.data.data.Key; 
                        let extension = fileKey.split('.').pop();

                        this.setBannerMedium({
                            key: fileKey,
                            old_key: fileKey,
                            temp_key: id,
                            size: file_size.toString(),
                            extension: extension,
                            uploadedBy: user.first_name + ' ' + user.last_name,
                            uploadedAt: '2023.01.01',
                        });
                    }
                    
                } catch (e) {
                    console.log("Error in set",e);
                    this.$flashMessage.show({
                    group: 'event_hall_index',
                    type: 'error',
                    title: 'Error',
                    html  : "<ul><li>Invalid File/Doc format.Please use described valid format</li></ul>"
                    });
                }
        },
        removeBannerMediumAsset(e, id) {
            console.log("Remove Medium Banner=====>",id);
            this.$swal({
                title: "Are you sure ? ",
                text: "To fully delete the file submit the form.",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "Delete",
                confirmButtonColor: "#dd4b39",
                focusCancel: true,
                reverseButtons: true
            }).then(result => {
                if (typeof result.dismiss === "undefined") {
                    remove(id).then(() => {
                    this.removeBannerMedium(id);
                    })
                }
            });
        },
        errCb(e){
            this.$flashMessage.show({
                group : 'event_hall_index',
                type  : 'error',
                title : 'Failed',
                html  : "<ul><li>Invalid File/Doc format.Please use described valid format</li></ul>"

            })
        }

       
        
       
       
        
        
        
        
        
    }
}
</script>
